<template>
  <nav v-if="user" class="navbar navbar-default">
    <div class="navbar__container">
      <div class="navbar-header">
        <a href="#" class="navbar-header-logo d-md-none">
          <logo></logo>
        </a>
        <LangCheck class="navbar-langs navbar-right" />
        <button type="button" class="navbar-toggle" :class="{toggled:   showSidebar}" @click.prevent.stop="toggleMobileSidebar">
          <span class="unreadNotificationsCount" v-if="unreadNotificationsCount">{{unreadNotificationsCount}}</span>
          <span class="sr-only">{{ $t('common.navigation') }}</span>
          <span class="icon-bar bar1"></span>
          <span class="icon-bar bar2"></span>
          <span class="icon-bar bar3"></span>
        </button>
        <div class="navbar-minimize">
          <button class="btn btn-icon noHideSidebar" @click.prevent="toggleSidebar">
            <img src="static/img/icon_more.svg" alt="Icon" class="navbar-minimize__more">
            <img src="static/img/icon_bars.svg" alt="Icon" class="navbar-minimize__bars">
          </button>
        </div>
      </div>
      <div class="collapse navbar-collapse">
        <div class="navbar-search navbar-left">
          <!-- <inline-search></inline-search> -->
        </div>
        <LangCheck class="navbar-langs navbar-right" />
        <div class="user-info navbar-right" @click="profileDropDown =! profileDropDown" v-click-outside="closeProfileDropDown">
          <avatar class="user-info__photo"
                  :upic="user.getUpic()"
                  :name="user.getLastName()"
                  size="ic">
          </avatar>
          <div class="user-info__text">
            <div class="user-info__name">
              <span> {{user.getFullName() }}</span>
            </div>
            <div class="user-info__post">
              {{user.getPostsText() }}
            </div>
          </div>
          <drop-down tag="div" :is-opened="profileDropDown">
            <b
              slot="title"
              class="caret"
              :class="{'caret--opened': profileDropDown}"
            />
            <li>
              <router-link :to="{ name: 'profilePage'}">
                <span>{{ $t('common.dropdown_menu.my_profile') }}</span>
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: !isAdmin ? 'profileEdit' : 'userEdit', params: { id: user.getId() } }">
                <span>{{ $t('common.dropdown_menu.edit_profile') }}</span>
              </router-link>
            </li>
            <li>
              <a href="javascript:void(0)" @click="logout()">
                <span>{{ $t('common.dropdown_menu.logout') }}</span>
              </a>
            </li>
          </drop-down>
        </div>
        <ul class="nav navbar-nav navbar-right topIcons">
          <drop-down tag="li" title="8" icon="static/img/icon_clipboard.svg"  v-if="false">
            <li><a href="#">Задача 1</a></li>
            <li><a href="#">Задача 2</a></li>
            <li><a href="#">Задача 3</a></li>
            <li><a href="#">Задача 4</a></li>
          </drop-down>
          <li v-if="false" class="btn-rotate">
            <a href="#" @click.prevent.stop="toggleNotificationsPanel">
              <img src="static/img/icon_bell.svg" alt="Icon" class="nav-icon">
              <p class="notification notification--top" v-if="unreadNotificationsCount">{{unreadNotificationsCount}}</p>
            </a>
          </li>
          <li v-if="false">
            <router-link to="/" class="btn-rotate"  >
              <img src="static/img/icon_settings.svg" alt="Icon" class="nav-icon">
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
  import avatar from 'src/components/Avatar/avatar.vue'
  import auth from 'src/services/auth';
  import logo from 'src/components/Logo/Logo.vue'
  import dropDown from 'src/components/Dropdown/Dropdown.vue'
  import localStorageTransport from 'src/services/localStorageTransport'
  import {USER_ROLE_ADMIN} from '@/constants'
  import LangCheck from '@/components/Langs/LangCheck.vue';

  export default {
    props: [
      'user'
    ],
    components: {
      avatar,
      logo,
      dropDown,
      LangCheck
    },
    data () {
      return {
        sidebarIsMinimize: false,
        activeNotifications: false,
        profileDropDown: false
      }
    },
    computed: {
      sidebarMinimized () {
        return this.$store.state.sidebarMinimized
      },
      unreadNotificationsCount () {
        return 0
      },
      editLink: self => {
        if (self.isAdmin) {
          return 'userEdit'
        } else {
          return 'profileEdit'
        }
      },
      showSidebar () {
        return this.$store.state.sidebarOpened;
      },
      isAdmin () {
        return this.user.checkRole(USER_ROLE_ADMIN)
      }
    },
    methods: {
      toggleMobileSidebar () {
        this.$store.commit('sidebarOpened')
      },
      closeProfileDropDown () {
        this.profileDropDown = false;
      },
      toggleSidebar () {
        this.$store.commit('sidebarMinimized')
      },
      toggleNotificationsPanel () {
        this.$store.commit('notifications/toggleExpanded')
      },
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      closeDropDown () {
        this.activeNotifications = false
      },
      logout () {
        this.$store.dispatch('user/logout').then(() => {
          this.$router.push('/login')
        }).catch(() => {
          this.$router.push('/login')
        }).finally(() => {
          localStorageTransport.emit('logout', true)
        })
      }
    }
  }

</script>
<style lang="scss">
  @import '../../../assets/sass/grid';
  .navbar {
    height: 76px !important;
    max-width: $width-xl;
    margin: 0 auto;
    transition: all .4s ease !important;
    width: 100%;
    @media (min-width: $width-xl) {
      left: calc((100vw - #{$width-xl}) / 2);
    }
    @media (min-width: $width-lg) {
      position:fixed;
      z-index: 2;
    }
    &__container {
      background-color: #fff;
      border-bottom: 1px solid #E4E7ED;
      height: 100%;
      transition: width .4s ease;
      .navbar-collapse {
        padding: 0 30px;
        display: flex !important;
        align-items: center;
      }
      &::after {
        content: '';
        top:0;
        left: calc(100%);
        display: block;
        position: absolute;
        background: #fff;
        border-bottom: 1px solid #E4E7ED;
        height: 76px;
        width:  calc((100vw - #{$width-xl}) / 2);
        right: auto;
      }
      .navbar-header-logo {
        margin-left: 10px;
      }
    }
    &-minimize{margin-left: 30px;}
    .logo__text{font-size: 14px; white-space: normal;}
    &-header-logo{margin-left: 0;}
    &-default{
      background-color:transparent !important;
      border-bottom: 0 !important;
    }
    &-header{
      display: flex;
      align-items: center;
      margin-left: 0;
    }
    .topIcons {
      > li {
        padding: 0 4px;
      }
    }
    .navbar-minimize {
      margin-right: 20px;
      margin-left: 20px;
      transition: all .4s ease;
    }
    .unreadNotificationsCount {
      position: absolute;
      background: #FF3738;
      font-size: 12px;
      color: #fff;
      height: 20px;
      line-height: 20px;
      top: -6px;
      right: -8px;

      border-radius: 10px;
      padding: 0 6px;
      font-weight: 500;
      text-align: center;
      z-index: 5;
    }
  }

  .navbar-langs.el-dropdown {
    margin-left: auto;
  }
</style>